import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { BillToSelectionStylesStyles } from "@store/Components/Customer/BillToSelection";
import { css } from "styled-components";

export const sharedStyled: BillToSelectionStylesStyles = {
    selectorDynamicDropdown: {
        css: css`
            .is-selected {
                background-color: ${getColor("table.selected")} !important;

                td {
                    color: ${getColor("common.background")};
                }
            }
        `,
    },
    customerRow: {
        css: css`
            &:hover {
                background-color: ${getColor("table.hover")};
                cursor: pointer;
            }
        `,
    },
    selectionTitle: {
        forwardAs: "h2",
        variant: "h2",
    },
    searchGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    customerTableColHeader: {
        css: css`
            width: 30%;
        `,
    },
    radioRowHeader: {
        css: css`
            width: 5%;
        `,
    },
    idRowHeader: {
        css: css`
            width: 10%;
        `,
    },
    addressTableColHeader: {
        css: css`
            width: 40%;
        `,
    },
    cityTableColheader: {
        css: css`
            width: 15%;
        `,
    },
    table: {
        css: css`
            width: 100%;
        `,
    },
    contentWrapper: {
        css: css`
            width: 100%;
            display: block;
            margin-bottom: 15px;
        `,
    },
    tableWrapper: {
        css: css`
            width: 100%;
            overflow: auto;
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${GridOffset} {
                width: 100%;
                margin: 5px 0 10px;
            }
        `,
    },
};
